// ======================================
// TimeSmart – Roller & behörigheter (JS)
// ======================================

// Tillåtna nivåer:
// "none"  = ingen åtkomst
// "view"  = läsa / se
// "edit"  = full åtkomst

/**
 * INTERN roll-nyckel (svenska) → Capability → PermissionLevel
 * Alla roller finns kvar för nuvarande & framtida bruk
 */
export const ROLE_PERMISSIONS = {
  // =====================================
  // SUPERADMIN – full kontroll över allt
  // =====================================
  superadmin: {
    schedule: "edit",
    employees: "edit",
    
    cases: "edit",
    "cases:overtime": "edit",
    "cases:absence": "edit",
    
    projects: "edit",
    "projects:groups": "edit",
    "projects:overview": "edit",
    
    customers: "edit",
    
    payroll: "edit",
    "payroll:ob": "edit",
    "payroll:overtime": "edit",
    "payroll:absence": "edit",
    "payroll:export": "edit",
    
    settings: "edit",
    "settings:companySettings": "edit",
    "settings:company": "edit",
    "settings:roles": "edit",
    "settings:subscription": "edit",
    
    invoices: "edit",
    
    // LÄGG TILL RAPPORTER BEHÖRIGHET
    reports: "edit",
    
    // MEDDELANDEN (anslagstavla)
    notices: "edit",

    // TIME SMART+ BEHÖRIGHET
    timesmart: "edit",
  },

  // =====================================
  // ADMINISTRATÖR – samma rättigheter
  // =====================================
  administratör: {
    schedule: "edit",
    employees: "edit",
    
    cases: "edit",
    "cases:overtime": "edit",
    "cases:absence": "edit",
    
    projects: "edit",
    "projects:groups": "edit",
    "projects:overview": "edit",
    
    customers: "edit",
    
    payroll: "edit",
    "payroll:ob": "edit",
    "payroll:overtime": "edit",
    "payroll:absence": "edit",
    "payroll:export": "edit",
    
    settings: "edit",
    "settings:companySettings": "edit",
    "settings:company": "edit",
    "settings:roles": "edit",
    "settings:subscription": "none",
    
    invoices: "edit",
    
    // LÄGG TILL RAPPORTER BEHÖRIGHET
    reports: "edit",
    
    // MEDDELANDEN (anslagstavla)
    notices: "edit",

    // TIME SMART+ BEHÖRIGHET
    timesmart: "edit",
  },

  // =====================================
  // SCHEMALÄGGARE – framtida roll
  // =====================================
  schemaläggare: {
    schedule: "edit",
    employees: "view",
    
    cases: "edit",
    "cases:overtime": "edit",
    "cases:absence": "edit",
    
    projects: "edit",
    "projects:groups": "edit",
    "projects:overview": "view",
    
    customers: "edit",
    
    payroll: "none",
    "payroll:ob": "none",
    "payroll:overtime": "none",
    "payroll:absence": "none",
    "payroll:export": "none",
    
    settings: "view",
    "settings:companySettings": "none",
    "settings:company": "none",
    "settings:roles": "none",
    "settings:subscription": "none",
    
    invoices: "view",
    
    // LÄGG TILL RAPPORTER BEHÖRIGHET
    reports: "view",

    
    // MEDDELANDEN (anslagstavla)
    notices: "edit",

    // TIME SMART+ BEHÖRIGHET
    timesmart: "view",
  },

  // =====================================
  // LÖNEHANTERARE – framtida roll
  // =====================================
  lönehanterare: {
    schedule: "view",
    employees: "view",
    
    cases: "view",
    "cases:overtime": "view",
    "cases:absence": "view",
    
    projects: "view",
    "projects:groups": "none",
    "projects:overview": "view",
    
    customers: "view",
    
    payroll: "edit",
    "payroll:ob": "edit",
    "payroll:overtime": "edit",
    "payroll:absence": "edit",
    "payroll:export": "edit",
    
    settings: "view",
    "settings:companySettings": "none",
    "settings:company": "none",
    "settings:roles": "none",
    "settings:subscription": "none",
    
    invoices: "edit",
    
    // LÄGG TILL RAPPORTER BEHÖRIGHET
    reports: "edit",
    
    // TIME SMART+ BEHÖRIGHET
    timesmart: "edit",
  },

  // =====================================
  // GRANSKARE – framtida roll (read-only)
  // =====================================
  granskare: {
    schedule: "view",
    employees: "view",
    
    cases: "view",
    "cases:overtime": "view",
    "cases:absence": "view",
    
    projects: "view",
    "projects:groups": "view",
    "projects:overview": "view",
    
    customers: "view",
    
    payroll: "view",
    "payroll:ob": "view",
    "payroll:overtime": "view",
    "payroll:absence": "view",
    "payroll:export": "none",
    
    settings: "view",
    "settings:companySettings": "none",
    "settings:company": "view",
    "settings:roles": "none",
    "settings:subscription": "none",
    
    invoices: "view",
    
    // LÄGG TILL RAPPORTER BEHÖRIGHET
    reports: "view",
    
    // TIME SMART+ BEHÖRIGHET
    timesmart: "view",
  },

  // =====================================
  // ANVÄNDARE – nuvarande "user"
  // =====================================
  användare: {
    schedule: "none",
    employees: "none",
    
    cases: "none",
    "cases:overtime": "none",
    "cases:absence": "none",
    
    projects: "none",
    "projects:groups": "none",
    "projects:overview": "none",
    
    customers: "none",
    
    payroll: "none",
    "payroll:ob": "none",
    "payroll:overtime": "none",
    "payroll:absence": "none",
    "payroll:export": "none",
    
    settings: "none",
    "settings:companySettings": "none",
    "settings:company": "none",
    "settings:roles": "none",
    "settings:subscription": "none",
    
    invoices: "none",
    
    // LÄGG TILL RAPPORTER BEHÖRIGHET
    reports: "none",

    
    // TIME SMART+ BEHÖRIGHET
    timesmart: "none",
  },
};

/**
 * Översätter AKTUELLA systemroller → interna svenska roller
 * Detta är den ENDA bryggan
 */
export function normalizeRole(role) {
  switch (role) {
    // English → internal Swedish
    case "super-admin":
      return "superadmin";
    case "admin":
      return "administratör";
    case "scheduler":
      return "schemaläggare";
    case "payroll-manager":
      return "lönehanterare";
    case "viewer":
      return "granskare";
    case "user":
      return "användare";

    // Already normalized (backend or future)
    case "superadmin":
    case "administratör":
    case "schemaläggare":
    case "lönehanterare":
    case "granskare":
    case "användare":
      return role;

    default:
      return null;
  }
}

/**
 * Returnerar behörighet för roll + capability
 * Alltid säker fallback till "none"
 */
export function getPermission(role, capability) {
  const normalizedRole = normalizeRole(role);
  if (!normalizedRole) return "none";

  return ROLE_PERMISSIONS[normalizedRole]?.[capability] ?? "none";
}
